import React from 'react';
import ProjectListContainer from '../../containers/projectmng/ProjectListContainer';

const ProjectListPage = () => {
  const pageUrl = '/projectmng';
  return <ProjectListContainer pageUrl={pageUrl}/>
};

export default ProjectListPage;
